import { create } from 'zustand';
import { Cruise } from '../components/CruiseList/Types';

export const CRUISE_ERROR = Symbol('CRUISE_ERROR');

type CruiseState = null | Cruise | typeof CRUISE_ERROR;

export const useCruiseStore = create<{
  cruise: CruiseState;
  setCruise: (cruise: CruiseState) => void;
}>((set) => ({
  cruise: null,
  setCruise: (cruise: CruiseState) => set(() => ({ cruise })),
}));
